// extracted by mini-css-extract-plugin
module.exports = {"Slider":"Slider_Slider__vrhzn","Back":"Slider_Back__8p55E","Title":"Slider_Title__8A4ny","Content":"Slider_Content__Yhvr1"};